import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { get } from "lodash";
import awsImageUpload from "../../../helpers/awsImageUpload";
import {
  UPDATE_NOTE_REQUEST,
  UPDATE_NOTE_SUCCESS,
  UPDATE_NOTE_FAILURE
} from "../types";
import { addEntities } from "../../entities";

export default (factorCompanyId, noteId, note, attachments) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(UPDATE_NOTE_REQUEST)({}));
    const response = await api.factorCompany.updateNote(factorCompanyId, {
      id: noteId,
      note,
      attachments
    });

    const upload = get(response, "attachments.0.upload_url");
    if (upload) {
      await awsImageUpload([
        {
          file: attachments,
          upload_url: upload
        }
      ]);
    }

    const data = normalize(response, schema.notes);

    dispatch(addEntities(data.entities));
    dispatch(
      createAction(UPDATE_NOTE_SUCCESS)({
        [factorCompanyId]: [data.result]
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(UPDATE_NOTE_FAILURE)(err));
    throw err;
  }
};
